import React from 'react';
import Chip from '../../Fundamentals/Chip/Chip';

const FilterCard = ({
  children,
  selectedItems = [],
  onRemoveItem,
  maxVisibleItems = 6,
  renderCustomBody = null,
  disabled = false,
  isNotImplemented = false,
}) => {
  const shouldScroll = selectedItems.length > maxVisibleItems;
  const minSlots = 3;
  const ghostCount = Math.max(0, minSlots - selectedItems.length);

  return (
    <div className="filter-card">
      <div className={`filter-card-header ${disabled ? 'disabled' : ''}`}>{children}</div>

      <div className={`filter-card-body ${shouldScroll ? 'scrollable' : ''}`}>
        {renderCustomBody ? (
          renderCustomBody()
        ) : (
          <div className="filter-card-slots">
            {selectedItems.map((item, index) => (
              <Chip
                key={item.id || index}
                label={item.name || item.label || String(item)}
                onRemove={() => onRemoveItem && onRemoveItem(item)}
              />
            ))}

            {Array.from({ length: ghostCount }).map((_, index) => (
              <div key={`ghost-${index}`} className="filter-card-ghost-pill"></div>
            ))}
          </div>
        )}
      </div>
      
      {isNotImplemented && (
        <div className="disabled">
          <p className="m-0 text-center">Not yet implemented!</p>
        </div>
      )}
    </div>
  );
};

export default FilterCard;
